import { UseControllerProps } from "react-hook-form";

/**
 * Get form label string
 */
export const getLabel = (label: string, rules: UseControllerProps["rules"]) =>
  `${label}${rules?.required ? " *" : ""}`;
